<template>
  <CdrContainer class="signed-out">
    <CdrText tag="h1"> You've been signed out</CdrText>
    <CdrText class="signed-out__message">
      If your account is open in a different browser, device or the REI app, you'll need to sign out
      there separately.
    </CdrText>
    <CdrText tag="h2"> Sign back in for: </CdrText>
    <CdrList class="signed-out__list">
      <li class="signed-out__list-item">
        <IconCheckSm class="signed-out__check-icon" />Speedier checkout
      </li>
      <li class="signed-out__list-item">
        <IconCheckSm class="signed-out__check-icon" />Convenient order tracking
      </li>
      <li class="signed-out__list-item">
        <IconCheckSm class="signed-out__check-icon" />Member access to Total REI Rewards
      </li>
    </CdrList>
    <CdrButton class="signed-out__button" tag="a" href="/login" modifier="secondary">
      Sign in
    </CdrButton>
  </CdrContainer>
</template>

<script setup>
import { CdrButton, CdrContainer, CdrList, CdrText, IconCheckSm } from '@rei/cedar';
</script>

<style lang="scss">
@import '@rei/cedar/dist/cdr-reset.css';
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

#app {
  h1 {
    @include cdr-text-heading-serif-900;

    @include cdr-sm-mq-down {
      @include cdr-text-heading-serif-700;
    }
  }

  h2 {
    @include cdr-text-utility-sans-strong-300;
  }

  p {
    @include cdr-text-utility-sans-300;
  }

  ul {
    margin-top: $cdr-space-half-x;
  }

  .signed-out {
    margin-block: $cdr-space-four-x;
    padding: 0;
    max-width: 450px;

    @include cdr-sm-mq-down {
      margin-bottom: 0;
      padding: 0 $cdr-space-one-x;
    }

    &__message {
      margin: $cdr-space-one-and-a-half-x 0;
    }

    &__list {
      margin-top: $cdr-space-one-x;
    }

    &__list-item {
      @include cdr-text-utility-sans-200;

      display: flex;
      padding-left: $cdr-space-one-x;
    }

    &__check-icon {
      width: $cdr-icon-size;
      fill: $cdr-color-icon-message-success;
    }

    &__button {
      margin-top: $cdr-space-one-and-a-half-x;
      margin-bottom: $cdr-space-four-x;
    }
  }
}
</style>
